import React from 'react';

const International = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        For international users, we ensure:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Compliance with GDPR and other international privacy laws</li>
        <li>Appropriate safeguards for international data transfers</li>
        <li>Respect for local privacy regulations</li>
        <li>Transparent data processing practices</li>
      </ul>
    </div>
  );
};

export default International;